import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './About.css';

function About() {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Track page view with GTM dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'page_view',
      page_title: 'About Us - rkube Services',
      page_location: window.location.href,
      page_path: window.location.pathname
    });
  }, []);
  
  const navigateToHomeServices = (e) => {
    e.preventDefault();
    
    // Use direct location setting for more reliable hash navigation
    window.location.href = '/#services';
    
    // The scrolling will be handled by the Home component's hash change listener
  };

  return (
    <div className="page-container about-page">
      {/* Hero Banner Section */}
      <section className="about-hero-banner">
        <div className="hero-overlay"></div>
        <div className="hero-image-container">
          <img src="/images/about-team.png" alt="Our team" className="hero-image" />
        </div>
        <div className="container">
          <h1>About Us</h1>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="about-content">
        <div className="container">
          <p className="intro-description">
          We are a team passionate about empowering founders and established businesses. 
          We help manage your books, taxes, people & payroll, equity management, compliance, and company setup, 
          giving you the clarity to run your business with confidence.
          </p>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <h2>100's</h2>
              <p>of companies trust us</p>
            </div>
            <div className="stat-item">
              <h2>&gt; $1M</h2>
              <p>in funding by PE's</p>
            </div>
            <div className="stat-item">
              <h2>20+</h2>
              <p>team members</p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="mission-vision-section">
        <div className="container">
          <div className="mission-box">
            <h2>Our mission</h2>
            <p>
            To simplify financial and operational complexity for founders and businesses by delivering 
            expert support across books, tax, equity management, people, compliance, and company setup
             — so they can focus on growth with confidence.
            </p>
          </div>
          
          <div className="vision-box">
            <h2>Our vision</h2>
            <p>
            To build a world where running a business is simple, transparent, 
            and supported by trusted systems, allowing every company to focus on its purpose, 
            not its paperwork.
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="container">
          <h2>Our values</h2>
          <p className="values-description">
          We value clarity, reliability, and partnership. We believe in making complex processes simple, 
          delivering accurate and timely service, and building long-term relationships based on trust. 
          Every decision we make is driven by our commitment to helping businesses succeed with confidence.

          </p>
        </div>
      </section>

      {/* Standards Section */}
      <section className="standards-section">
        <div className="container">
          <h2>Standards we live by</h2>
          
          <div className="standards-grid">
            <div className="standard-item">
              <h3>Clarity</h3>
              <p>
              We communicate clearly, explain every step, and ensure you always know where your business stands.


              </p>
            </div>
            
            <div className="standard-item">
              <h3>Accuracy</h3>
              <p>
              From payroll to tax filings, precision is our priority. We double check the details so you can trust the results.


              </p>
            </div>
            
            <div className="standard-item">
              <h3>Responsiveness</h3>
              <p>
              Your questions deserve fast answers. We stay accessible and ready to help when you need us most.


              </p>
            </div>
            
            <div className="standard-item">
              <h3>Scalability</h3>
              <p>
              Whether you are just starting out or expanding fast, our services grow with your business without slowing you down.


              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2>Ready to simplify your financial operations?</h2>
          <p>Join hundreds of startups who trust us with their financial management and compliance.</p>
          <div className="cta-buttons">
            <a href="/#services" onClick={navigateToHomeServices} className="btn btn-primary">Get Started</a>
            {/* <button className="btn btn-outline">Book a Demo</button> */}
          </div>
        </div>
      </section>
    </div>
  );
}

export default About; 